/**
 * Reassurances Carousel - Mobile Only
 * Simple carousel with dots navigation and autoplay (5s) for mobile
 */

(function () {
  "use strict";

  function initReassurancesCarousel() {
    const carousel = document.querySelector('[data-reassurances-carousel]');
    const dotsContainer = document.querySelector('[data-reassurances-dots]');

    if (!carousel || !dotsContainer) return;

    const slides = carousel.querySelectorAll('.reassurance-slide');
    const dots = dotsContainer.querySelectorAll('.reassurances-pagination__dot');

    if (slides.length === 0 || dots.length === 0) return;

    let currentIndex = 0;
    let autoplayInterval = null;
    const AUTOPLAY_DELAY = 5000; // 5 secondes

    // Update active dot
    function updateActiveDot(index) {
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('active');
          dot.removeAttribute('aria-current');
        }
      });
    }

    // Scroll to specific slide
    function scrollToSlide(index) {
      const slide = slides[index];
      if (slide) {
        const slideWidth = slide.offsetWidth;
        carousel.scrollTo({
          left: slideWidth * index,
          behavior: 'smooth'
        });
      }
    }

    // Go to next slide (loop to start if at end)
    function goToNextSlide() {
      currentIndex = (currentIndex + 1) % slides.length;
      scrollToSlide(currentIndex);
      updateActiveDot(currentIndex);
    }

    // Start autoplay
    function startAutoplay() {
      stopAutoplay(); // Clear existing interval
      autoplayInterval = setInterval(goToNextSlide, AUTOPLAY_DELAY);
    }

    // Stop autoplay
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Reset autoplay (stop then restart)
    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    // Handle dot click
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        currentIndex = index;
        scrollToSlide(index);
        updateActiveDot(index);
        resetAutoplay(); // Reset autoplay on user interaction
      });
    });

    // Detect scroll position and update dots
    let scrollTimeout;
    let isUserScrolling = false;

    carousel.addEventListener('scroll', () => {
      isUserScrolling = true;
      stopAutoplay(); // Stop autoplay during manual scroll

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const scrollLeft = carousel.scrollLeft;
        const slideWidth = slides[0].offsetWidth;
        const newIndex = Math.round(scrollLeft / slideWidth);

        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < slides.length) {
          currentIndex = newIndex;
          updateActiveDot(currentIndex);
        }

        // Restart autoplay after user stops scrolling
        isUserScrolling = false;
        if (window.innerWidth <= 768) {
          startAutoplay();
        }
      }, 150);
    });

    // Initialize first dot as active
    updateActiveDot(0);

    // Start autoplay only on mobile (max-width: 768px)
    if (window.innerWidth <= 768) {
      startAutoplay();
    }

    // Stop autoplay on window resize if not mobile anymore
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        stopAutoplay();
      } else if (!isUserScrolling && !autoplayInterval) {
        startAutoplay();
      }
    });

    // Pause autoplay when page is hidden (tab switching, etc.)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else if (window.innerWidth <= 768 && !isUserScrolling) {
        startAutoplay();
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReassurancesCarousel);
  } else {
    initReassurancesCarousel();
  }
})();
